var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "py-20px py-md-40px",
    attrs: {
      "elevation": "0"
    }
  }, [_vm.title ? _c('v-card-title', {
    staticClass: "tit tit--sm primary--text pt-0"
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")]) : _vm._e(), _c('v-card-text', {
    staticClass: "py-20px py-md-40px"
  }, [_c('div', {
    staticClass: "mx-auto",
    staticStyle: {
      "width": "100%",
      "max-width": "800px"
    }
  }, [_vm._t("default")], 2)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }